<template>
    <div
        :key="item.id + item.timestamp"
        class="vrm-tanks-list__tank"
        :class="[`tank-${item.fluidType}`, { 'is-low': item.isLow }]"
    >
        <div class="vrm-tanks-list__tank__fill" :style="fillStyle(item)"></div>
        <span
            v-if="detailMode"
            class="vrm-tanks-list__tank__label"
            :class="[{ yellow: hasLowFuel(item) }]"
        >
            {{ item.fillPercentage }} %
        </span>
        <span v-if="showTankType" class="vrm-tanks-list__tank__type">
            {{ item.fluidType.toString().replace('unknown', '?') }}
        </span>
        <span v-if="item.isLow" class="vrm-tanks-list__tank__low">LOW</span>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { tankSortOptions } from '@/vue/static/installationsTableConstants';
import { vrmConfig } from '@/config';

@Component
@AngularDirective('vrm-tank')
export default class VrmTank extends Vue {
    @Prop()
    item;

    @Prop({ type: Number, default: 0 })
    threshold;

    @Prop({ type: Boolean, required: true })
    detailMode;

    showTankType = !!vrmConfig.debugTankTypes;

    hasLowFuel(tank) {
        return tankSortOptions.SEWAGE.includes(tank.fluidType) //'Black water (sewage)'
            ? tank.fillPercentage >= 100 - this.threshold
            : tank.fillPercentage <= this.threshold;
    }

    fillStyle(tank) {
        return tank.remainingPercentage === '100%'
            ? { display: 'none' }
            : {
                  top: tank.remainingPercentage,
              };
    }

    get hasLow() {
        return this.tanks.some(tank => tank.isLow);
    }
}
</script>
